import {reactive} from "vue";

const mypowerlimits = reactive(JSON.parse(localStorage.getItem('powerlimits')))

export const usePermission = (permission) => mypowerlimits[permission]
